const { useEffect, useRef, useState, memo } = React;
let katexPromise;

function loadKatex() {
  if (katexPromise) return katexPromise;
  const css = document.createElement('link');
  css.rel = 'stylesheet'; css.href = '/vendor/katex/katex.min.css?v=144';
  const script = document.createElement('script');
  script.src = '/vendor/katex/katex.min.js?v=144'; script.async = true;
  const cssReady = new Promise((resolve, reject) => { css.onload = resolve; css.onerror = () => reject(new Error('math-css')); });
  const jsReady = new Promise((resolve, reject) => { script.onload = resolve; script.onerror = () => reject(new Error('math-js')); });
  katexPromise = Promise.all([cssReady, jsReady]).then(() => {
    if (!window.katex?.render) throw new Error('math-api');
    return window.katex;
  }).catch(error => { katexPromise = null; css.remove(); script.remove(); throw error; });
  document.head.append(css, script);
  return katexPromise;
}

export const Formula = memo(function Formula({ tex, display = false }) {
  const element = useRef(null), [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true; setFailed(false);
    // Bound untrusted expressions independently of the model's token budget.
    if (tex.length > 12000) { setFailed(true); return; }
    loadKatex().then(katex => {
      if (!alive || !element.current) return;
      try {
        katex.render(tex, element.current, {
          displayMode: display, throwOnError: false, strict: 'ignore', trust: false,
          maxExpand: 1000, maxSize: 20, macros: {}, output: 'htmlAndMathml',
        });
      } catch { element.current.textContent = tex; setFailed(true); }
    }).catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, [tex, display]);
  const Tag = display ? 'div' : 'span';
  return <Tag className={(display ? 'ai-formula-display' : 'ai-formula-inline') + (failed ? ' math-fallback' : '')} data-formula={display ? 'display' : 'inline'}><span ref={element}>{tex}</span>{failed && display && <small>公式暂以原文显示</small>}</Tag>;
});
